// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';
var wideScreen, showViewAlbumOnLoad
const isMobile = wixWindow.formFactor === "Mobile";
$w.onReady(function () {
	wixWindow.getBoundingRect()
  .then( (windowSizeInfo) => {
    let windowHeight = windowSizeInfo.window.height;     
    let windowWidth = windowSizeInfo.window.width;
	let scrollY = windowSizeInfo.scroll.y;
	const windowRatio = windowWidth/windowHeight;
	if (windowRatio > 1.5) {
		wideScreen = true;
	}
	if (scrollY < 50 && wideScreen) {
		$w('#box4').show('fade', {duration: 150})
	}
	if (scrollY < 50 && !isMobile) {
				$w('#box1').show('fade', { duration: 100 })
			}
  })
});




